module.exports = __webpack_public_path__ + "img/46.c30a0268.jpg";